/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StaffScopeSchema
 */
export interface StaffScopeSchema {
    /**
     * 
     * @type {number}
     * @memberof StaffScopeSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof StaffScopeSchema
     */
    type?: StaffScopeSchemaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StaffScopeSchema
     */
    name: string;
}


/**
 * @export
 */
export const StaffScopeSchemaTypeEnum = {
    CustomStaffList: 'custom-staff-list'
} as const;
export type StaffScopeSchemaTypeEnum = typeof StaffScopeSchemaTypeEnum[keyof typeof StaffScopeSchemaTypeEnum];


/**
 * Check if a given object implements the StaffScopeSchema interface.
 */
export function instanceOfStaffScopeSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function StaffScopeSchemaFromJSON(json: any): StaffScopeSchema {
    return StaffScopeSchemaFromJSONTyped(json, false);
}

export function StaffScopeSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffScopeSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'name': json['name'],
    };
}

export function StaffScopeSchemaToJSON(value?: StaffScopeSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
    };
}

